import { render, staticRenderFns } from "./media.vue?vue&type=template&id=b3191b72&scoped=true&"
import script from "./media.vue?vue&type=script&lang=js&"
export * from "./media.vue?vue&type=script&lang=js&"
import style0 from "./media.vue?vue&type=style&index=0&id=b3191b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3191b72",
  null
  
)

export default component.exports